import { render, staticRenderFns } from "./ProjectDocumentTemplateNew.vue?vue&type=template&id=517c04a0"
import script from "./ProjectDocumentTemplateNew.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentTemplateNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports